import {
  Body,
  FlexContainer,
  Span,
  useDialog,
  useLocales,
  type LocaleDictionaryType,
} from "@/lib/main";
import { type CSSProperties } from "react";

type DetailsDialogPropsType = {
  label: LocaleDictionaryType;
  heading?: LocaleDictionaryType;
  headingAlign?: CSSProperties["textAlign"] | "start";
  headingFontWeight?: 400 | 500 | 600;
  text: LocaleDictionaryType | LocaleDictionaryType[];
  textAlign?: CSSProperties["textAlign"] | "start";
};

export default function DetailsDialog({
  label,
  heading,
  headingAlign,
  headingFontWeight,
  text,
  textAlign,
}: DetailsDialogPropsType) {
  const l = useLocales();
  const { showDialog, setShowDialog, setContent } = useDialog();

  const labelStyle: CSSProperties = { cursor: "pointer", fontSize: "inherit" };
  const textStyle: CSSProperties = { whiteSpace: "pre-wrap" };

  const handleLabelClick = () => {
    if (showDialog) return;

    setContent(
      <FlexContainer direction="column" fullWidth>
        {heading ? (
          <Body
            lineHeight="2.25"
            style={textStyle}
            textAlign={headingAlign}
            fontWeight={headingFontWeight || 400}
          >
            {l(heading)}
          </Body>
        ) : null}

        {Array.isArray(text) ? (
          text.map((paragraph, index) => (
            <Body
              key={index}
              lineHeight="2.25"
              style={textStyle}
              textAlign={textAlign}
            >
              {l(paragraph)}
            </Body>
          ))
        ) : (
          <Body lineHeight="2.25" style={textStyle} textAlign={textAlign}>
            {l(text)}
          </Body>
        )}
      </FlexContainer>,
    );

    setShowDialog(true);
  };

  return (
    <Span color="link" onClick={handleLabelClick} style={labelStyle}>
      {l(label)}
    </Span>
  );
}
